import {Component} from "react";
import Glob from "../../../libs/Glob.mjs";
import {Button, ButtonGroup, Progress} from "reactstrap";
import ChevronLeftIcon from "../../../media/images/ChevronLeftIcon.mjs";
import TextLabel from "../../../controls/TextLabel/TextLabel.mjs";
import SkipToPreviousIcon from "../../../media/images/SkipToPreviousIcon.mjs";
import MySelect from "../../../controls/MySelect.mjs";
import SkipToNextIcon from "../../../media/images/SkipToNextIcon.mjs";
import appLib from "../../../libs/appLib.mjs";
import ListIcon from "../../../media/images/ListIcon.mjs";
import FullScreenModal from "../../../controls/FullScreen/FullScreenModal.mjs";
import AppSynthDataIcon from "../../../media/app-images/AppSynthDataIcon.mjs";
import AppPerimeterIcon from "../../../media/app-images/AppPerimeterIcon.mjs";
import AppPalleIcon from "../../../media/app-images/AppPalleIcon.mjs";
import "./SimulationFlowOver.css";
import AppDownloadIcon from "../../../media/app-images/AppDownloadIcon.mjs";
import ChevronRightIcon from "../../../media/images/ChevronRightIcon.mjs";
import PeriGraphic from "../../../ComponentParts/Perimeters/PeriGraphic.mjs";

const prefix = "SimulationFlowOver";

/**
 * @typedef stepData
 * @type {FallingByStep|boolean}
 * @private
 */

/**
 * @typedef FallingByStep
 * @type {Object}
 * @private
 * @property {Array<FallingItemByStep>} items
 */

/**
 * @typedef FallingItemByStep
 * @type {Object}
 * @private
 * @property {boolean} [fallen]
 * @property {boolean} [falling]
 * @property {string} [by]
 * @property {number} [delay]
 * @property {Record<"c"|"i"|"a"|"o",number>} status
 * @property {Object} [data]
 * @property {string} [data.type]
 * @property {string} [data.name]
 * @property {string} [data.subject]
 * @property {string} [data.subjectName]
 */


const SimulationFlowOver = class extends Component {
	constructor(props) {
		super(props);
		const steps = [];
		(props.simul?.run?.operativo?.steps||[]).filter( x => !! x).forEach( x=>{
			steps.push({ value: x, label: x.startsWith('trigger') ? x : 'Step '+String(steps.length).padStart(3,'0')+' - operativo', operativo: true });
		});
		if ( steps.length > 2 ) steps.pop();
		if ( props.simul?.run?.strategico?.steps ) {
			(props.simul.run.strategico.steps).filter( x => !! x).forEach( x => {
				steps.push({ value: x, label: x.startsWith('trigger') ? x : 'Step '+String(steps.length).padStart(3,'0')+' - strategico', strategico: true });
			});
			if ( props.simul.run.strategico.steps.length > 2 ) steps.pop();
		}
		this.state = {
			firstStep: steps[0].value,
			currentStep: steps[0].value,
			lastStep: steps[steps.length - 1].value,
			stepOptions: steps,
			/** @type {stepData} */
			stepData: false,
			ll: Glob.getLanguageLong(),
			tableSort: { field: "name"},
			knownSteps: {}
		}
		this.uid = Glob.generateUid(prefix);
		this.loadStep = this.loadStep.bind(this);
		this.loadStepData = this.loadStepData.bind(this);
		this.tableSort = this.tableSort.bind(this);
		this.sortBy = this.sortBy.bind(this);
	}
	componentDidMount() {
		setTimeout( this.loadStep );
	}
	loadStepData( stepID ) {
		return new Promise( (resolve,reject) => {
			if ( this.state.knownSteps[ stepID ] ) resolve( structuredClone(this.state.knownSteps[ stepID ]) );
			const payload = {
				simul: this.props.simul?.id,
				step: this.state.currentStep,
				verbose: true
			};
			appLib.api("simul/get-falling-by-step",payload).then( x => {
				const k = this.state.knownSteps;
				k[stepID] = x;
				this.setState( { knownSteps: k }, ()=>{
					resolve( structuredClone(x) );
				});
			}).catch( err => {
				console.error(payload, err);
				reject( err );
			});
		})
	}
	loadStep() {
		return new Promise( resolve => {
			if ( ! this.state.currentStep ) return resolve();
			this.setState({ stepData: false, stepLoading: true }, async ()=>{
				const ns = {};
				if ( ! this.state.triggers ) {
					const t = await this.loadStepData('trigger');
					ns.triggers = t.items.map( x => x.id );
				}
				this.loadStepData( this.state.currentStep ).then( x => {
					const s = {};
					const bys = [];
					x.items.forEach( x => {
						s[x.id] = x.status;
						if ( x.by ) bys.push( { source: x.id, target: x.by } );
					});
					ns.stepSelected = s;
					ns.bys = bys;
					this.setState( ns, ()=>{
						this.tableSort(x);
					});
				}).catch( err => {
					ns.stepLoading = false;
					this.setState(ns);
				})
			})
		});
	}
	tableSort( data ) {
		if ( typeof data === 'undefined') data = this.state.stepData;
		if ( ! data?.items || ! data.items.length ) return;
		const criteria = this.state.tableSort;
		data.items.sort( ( a, b ) =>  (a.data.name.toLocaleLowerCase(this.state.ll).localeCompare(b.data.name.toLocaleLowerCase(this.state.ll))));
		switch (criteria.field ) {
			case "type": data.items.sort( ( a, b ) =>  (a.data.type.localeCompare(b.data.type))); break;
			case "subject": data.items.sort( ( a, b ) =>  (a.data.subjectName.toLocaleLowerCase(this.state.ll).localeCompare(b.data.subjectName.toLocaleLowerCase(this.state.ll)))); break;
			case "c": data.items.sort( ( a, b ) =>  ( (a.status.c??0) - (b.status.c??0))); break;
			case "i": data.items.sort( ( a, b ) =>  ( (a.status.i??0) - (b.status.i??0))); break;
			case "a": data.items.sort( ( a, b ) =>  ( (a.status.a??0) - (b.status.a??0))); break;
			case "o": data.items.sort( ( a, b ) =>  ( (a.status.o??0) - (b.status.o??0))); break;
			default: break;
		}
		if (criteria.reverse) data.items.reverse();
		this.setState({ stepData: data, stepLoading: false });
	}
	sortBy( col ) {
		const s = this.state.tableSort;
		if ( s.field === col ) {
			s.reverse = ! s.reverse;
		} else {
			s.field = col;
			delete s.reverse;
		}
		this.setState({ tableSort: s }, this.tableSort);
	}
	render() {
		return(
			<>
				<div
					className={"panel-content "+prefix}
					style={{maxWidth:"min(100vw, 100%, 1600px)",margin:"0 auto"}}
				>
					<div className={"limited"}>
						<h3>
							<TextLabel value={"Simulation completed"} />
						</h3>
						<div className={"d-flex align-items-center"}>
							<Button
								color="primary"
								className={"btn-icon"}
								disabled={ this.state.stepLoading || this.state.currentStep === this.state.firstStep }
								onClick={ ()=>{ this.setState({currentStep: this.state.firstStep}, this.loadStep) }}
							>
								<i>
									<SkipToPreviousIcon />
								</i>
								<b>
									<TextLabel value={"Simulation started"} />
								</b>
							</Button>
							<Button
								color="primary"
								className={"btn-icon ms-2"}
								disabled={ this.state.stepLoading || this.state.currentStep === this.state.firstStep }
								onClick={ ()=>{
									const options = this.state.stepOptions;
									const curIndex = options.findIndex( x => x.value === this.state.currentStep );
									this.setState({currentStep: options[ curIndex -1].value }, this.loadStep)
								}}
							>
								<i>
									<ChevronLeftIcon />
								</i>
							</Button>
							<div className={"ps-2 pe-2 flex-grow-1"}>
								<MySelect
									isDisabled={ this.state.stepLoading }
									options={ this.state.stepOptions }
									value={ this.state.stepOptions.find( x => x.value === this.state.currentStep ) }
									onChange={ x => this.setState({currentStep: x?.value}, this.loadStep )}
								/>
							</div>
							<Button
								color="primary"
								className={"btn-icon me-2"}
								disabled={ this.state.stepLoading || this.state.currentStep === this.state.lastStep }
								onClick={ ()=>{
									const options = this.state.stepOptions;
									const curIndex = options.findIndex( x => x.value === this.state.currentStep );
									this.setState({currentStep: options[ curIndex +1].value }, this.loadStep)
								}}
							>
								<i>
									<ChevronRightIcon />
								</i>
							</Button>
							<Button
								color="primary"
								className={"btn-icon"}
								disabled={ this.state.stepLoading || this.state.currentStep === this.state.lastStep }
								onClick={ ()=>{ this.setState({currentStep: this.state.lastStep}, this.loadStep) }}
							>
								<b>
									<TextLabel value={"Simulation completed"} />
								</b>
								<i>
									<SkipToNextIcon />
								</i>
							</Button>
						</div>
					</div>
					{ (this.state.stepData) ? (
						<>
							<div className={"mt-2 mb-2 d-flex align-items-center justify-content-between"}>
								<div>
									<span><TextLabel value={"Falling nodes"} />: { (this.state.stepData.stepFall).toLocaleString(this.state.ll) }</span>
									{ ( this.state.stepData.stepFall !== this.state.stepData.totalFall) && <span> (<TextLabel value={"total"} />: { (this.state.stepData.totalFall).toLocaleString(this.state.ll) })</span> }
									<span> <TextLabel value={"on"} /> { (this.state.stepData.total).toLocaleString(this.state.ll) } </span>
								</div>
								<ButtonGroup
									className={"btn-icon"}
								>
									<Button
										color={"primary"}
										onClick={ () => {
											const simID = this.props.simul.id;
											const stepID = this.state.currentStep;
											appLib.api("simul/get-step", { simul: simID, step: stepID }).then( res =>{
												Glob.saveJSON( res, `simulation-${simID}-${stepID}.json` );
											})
										}}
									>
										<i>
											<AppDownloadIcon />
										</i>
										<b>
											<TextLabel value={"Download"} />
										</b>
									</Button>
									<Button
										disabled={ ! this.state.stepOptions.find( x => x.value === this.state.currentStep )?.operativo }
										color={"success"}
										onClick={ ()=>{ this.setState({ useGraphic: true })} }
									>
										<b>
											<TextLabel value={"View"} />
										</b>
										<i>
											<AppPalleIcon />
										</i>
									</Button>
								</ButtonGroup>
							</div>
							{ this.state.useGraphic && (
								<FullScreenModal
									title={ <>{ this.props.simul.fake ? <AppSynthDataIcon /> : <AppPerimeterIcon /> } <span>{this.props.simul.info.name}</span></> }
									toggle={ ()=>{ this.setState({ useGraphic: false } ) }}
								>
									<PeriGraphic
										id={ this.props.simul.info.peri }
										selected={ this.state.stepSelected }
										subjects={ this.props.simul.limitToSubject }
										triggers={ this.state.triggers }
										bys={ this.state.bys }
										simul={ this.props.simul?.id }
										nav={{
											canPrevious: ()=> { return (this.state.currentStep !== this.state.firstStep) },
											canNext: () => {
												const options = this.state.stepOptions;
												const curIndex = options.findIndex( x => x.value === this.state.currentStep );
												const nextStep = options[ curIndex +1];
												return !! nextStep?.operativo;
											},
											gotoPrevious: () => {
												const options = this.state.stepOptions;
												const curIndex = options.findIndex( x => x.value === this.state.currentStep );
												this.setState({currentStep: options[ curIndex -1].value }, this.loadStep)
											},
											gotoNext: () => {
												const options = this.state.stepOptions;
												const curIndex = options.findIndex( x => x.value === this.state.currentStep );
												this.setState({currentStep: options[ curIndex +1].value }, this.loadStep)
											},
										}}
									/>
								</FullScreenModal>
							)}
							<table className="table table-striped">
								<thead>
								<tr>
									<th
										className={ this.state.tableSort?.field === 'type' ? ('active'+( this.state.tableSort?.reverse ? ' reverse' : '')) : 'inactive'}
										role={ "button" }
										onClick={ ()=>{ this.sortBy('type')}}
									>
										<TextLabel value={"Type"} />
									</th>
									<th
										className={ this.state.tableSort?.field === 'name' ? ('active'+( this.state.tableSort?.reverse ? ' reverse' : '')) : 'inactive'}
										role={ "button" }
										onClick={ ()=>{ this.sortBy('name')}}
									>
										<TextLabel value={"Name"} />
									</th>
									<th
										className={ this.state.tableSort?.field === 'subject' ? ('active'+( this.state.tableSort?.reverse ? ' reverse' : '')) : 'inactive'}
										role={ "button" }
										onClick={ ()=>{ this.sortBy('subject')} }
									>
										<TextLabel value={"Subject"} />
									</th>
									<th
										className={ "text-center " + (this.state.tableSort?.field === 'c' ? ('active'+( this.state.tableSort?.reverse ? ' reverse' : '')) : 'inactive')}
										role={ "button" }
										onClick={ ()=>{ this.sortBy('c')}}
									>C</th>
									<th
										className={ "text-center " + (this.state.tableSort?.field === 'i' ? ('active'+( this.state.tableSort?.reverse ? ' reverse' : '')) : 'inactive')}
										role={ "button" }
										onClick={ ()=>{ this.sortBy('i')}}
									>I</th>
									<th
										role={ "button" }
										className={ "text-center " + (this.state.tableSort?.field === 'a' ? ('active'+( this.state.tableSort?.reverse ? ' reverse' : '')) : 'inactive')}
										onClick={ ()=>{ this.sortBy('a')}}
									>A</th>
									<th
										role={ "button" }
										className={ "text-center " + (this.state.tableSort?.field === 'o' ? ('active'+( this.state.tableSort?.reverse ? ' reverse' : '')) : 'inactive')}
										onClick={ ()=>{ this.sortBy('o')}}
									>O</th>
								</tr>
								</thead>
								<tbody>
								{ this.state.stepData.items.map( v => (
									<tr key={v.id} className={ v.fresh ? 'fresh' : 'previous'}>
										<td>{ v.data.type }</td>
										<td>{ v.data.name }</td>
										<td>{ v.data.subjectName }</td>
										<td className={"text-end"}>{ typeof v.status.c === 'number' ? String(Math.round( v.status.c * 100 ))+'%' : '—' }</td>
										<td className={"text-end"}>{ typeof v.status.i === 'number' ? String(Math.round( v.status.i * 100 ))+'%' : '—' }</td>
										<td className={"text-end"}>{ typeof v.status.a === 'number' ? String(Math.round( v.status.a * 100 ))+'%' : '—' }</td>
										<td className={"text-end"}>{ typeof v.status.o === 'number' ? String(Math.round( v.status.o * 100 ))+'%' : '—' }</td>
									</tr>
								))}
								</tbody>
							</table>
						</>
					) : (
						( !! this.state.stepLoading) && (
							<div className={"p-3 limited"}>
								<br />
								<Progress animated={true} value={100} striped />
								<br />
							</div>
						)
					)}
				</div>
				<div className={"panel-footer"}>
					<ButtonGroup className={"btn-icon"}>
						<Button
							color={"success"}
							onClick={()=>{ Glob.setCurrentPageParam('step','running') }}
						>
							<i>
								<ChevronLeftIcon />
							</i>
							<b>
								<TextLabel value={"Running"} />
							</b>
						</Button>
					</ButtonGroup>
					<ButtonGroup
						className={"btn-icon"}
					>
						<Button
							color={"success"}
							onClick={()=>Glob.gotoPage('Simulations')}
						>
							<b>
								<TextLabel value={"Available simulations"} />
							</b>
							<i>
								<ListIcon />
							</i>
						</Button>
					</ButtonGroup>
				</div>
			</>
		)
	}
}

export default SimulationFlowOver;